import React, { useState } from "react";
import mcarehd from "../../../../assets/images/mcarehd.png";
import mtnn from "../../../../assets/images/mtnblack.png";
import logo from "../../../../assets/images/md_logo.png";
import { useNavigate } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import CustomDrawer from "./drawer";

type NavProps = {
  className?: string;
};

export default function Nav({ className = "" }: NavProps) {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const showDrawer = () => {
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  return (
    <nav
      className={`shadow-lg bg-white w-full flex justify-between items-center rounded-lg h-16 px-3 ${className}`}
    >
      <div className="h-full flex flex-row items-center gap-2">
        <img src={mtnn} alt="care" className="md:h-8 h-4 rounded-l-lg" />
        <img src={logo} alt="care" className="md:h-7 h-4 rounded-l-lg" />
        <img src={mcarehd} alt="care" className="md:h-8 h-4 rounded-l-lg" />
      </div>

      <div className="md:flex hidden gap-6">
        <button
          onClick={() => navigate("/sign-in")}
          className="flex items-center justify-center gap-2 px-8 py-2 rounded-full border-black border  "
        >
          {/* <IoLogInOutline className="text-3xl" /> */}
          Log In
        </button>
        <button
          onClick={() => navigate("/sign-up")}
          className="bg-[#FFCC08] px-8 py-2 cursor-pointer rounded-full"
        >
          Register
        </button>
      </div>
      <div className="h-full flex items-center md:hidden cursor-pointer gap-3">
        <button
          onClick={() => navigate("/sign-in")}
          className="flex items-center justify-center gap-1 px-3 py-1 rounded-full border-black border "
        >
          {/* <IoLogInOutline size={20} className="text-3xl" /> */}
          Log In
        </button>
        <button title="Menu" className="text-gray-700 " onClick={showDrawer}>
          <GiHamburgerMenu size={20} />
        </button>
        <CustomDrawer open={drawerOpen} onClose={closeDrawer} />
      </div>
    </nav>
  );
}
